/* eslint-disabled */

export default class CommissionModelExtend {


  constructor (object?: any) {
  }

  postConstruct () {
  }
}
